<template>
  <div>
    <div class="public-top color-font-666 ">
      <div class="w1200 topbar">
        <div class="user-entry f-l">
          <div class="qm-ul-li f-l" style="width: 145px;">
            <div class="qm-ch-div">
              <a href="javascript:;"
                >{{ sitename }} [<span class="main-color">切换</span>]</a
              >
            </div>
            <div
              class="qm-ch-div1"
              style="background-color: transparent;border:none;"
            >
              <div class="home-tab-hover">
                <div
                  class="home-tab-list"
                  v-for="item in site_group"
                  :key="item.site_group_title"
                  v-if="!item.hidden"
                >
                  <img :src="item.icon_url" class="site-row-icon" />
                  <span class="site-row-title">{{ item.site_group_title }}</span>
                  <a
                    href="javascript:;"
                    :key="jindex"
                    @click="siteClick(child)"
                    class="site-row-name"
                    v-for="(child, jindex) in item.children"
                    v-if="child.is_show == 1"
                  >{{ child.site_name }}</a>
                </div>
              </div>
              <!-- <ul class="qm-ch-ul">
									<li><a href="javascript:;" @click="siteClick(item)" v-for="(item,index) in sitelist">{{item.site_name}}</a></li>
								</ul> -->
            </div>
          </div>
          <div v-if="membername">
            <span
              >您好 <a :href="userLink" target="_blank">{{ membername }}</a
              >,欢迎来到</span
            ><a
              class="main-color"
              :href="CurrentEnvPrefix.main + Common.getSourec().sitehost"
              target="_blank"
              >纺支宝</a
            ><span> [ <a href="javascript:;" @click="goout()">退出</a> ] </span>
          </div>
          <div v-else>
            <a
              class="main-color"
              :href="CurrentEnvPrefix.main + Common.getSourec().sitehost"
              target="_blank"
              >纺支宝</a
            ><span>欢迎你！</span>
            <a
              :href="CurrentEnvPrefix.login + '/?ref_url=' + ref_url"
              style="margin-left:20px;"
              >登录</a
            >
            <span
              ><a
                :href="CurrentEnvPrefix.login + '/login/login/register'"
                style="margin-left:20px;color: var(--main-color)"
                >免费注册</a
              ></span
            >
          </div>
        </div>

        <div class="quick-menu f-r">
          <ul class="qm-ul">
            <!--<li class="qm-ul-li">-->
            <!--  <div class="qm-ch-div">-->
            <!--    <a-->
            <!--      :href="-->
            <!--        CurrentEnvPrefix.main +-->
            <!--          Common.getSourec().sitehost +-->
            <!--          '/index.php?act=images&op=index'-->
            <!--      "-->
            <!--      target="_blank"-->
            <!--      >数据包生成</a-->
            <!--    >-->
            <!--  </div>-->
            <!--</li>-->
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >功能服务 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a href="javascript:;"
                      ><label
                        >以图搜款<input
                          type="file"
                          id="file"
                          name="card_z"
                          accept="image/png,image/jpeg,image/gif"
                          class="input-file"
                          hidefocus="true"
                          @change="uploadChange"
                          ref="upload"/></label
                    ></a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >我是商家 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a
                      :href="
                        CurrentEnvPrefix.main +
                          Common.getSourec().sitehost +
                          '/index.php?act=show_joinin&op=register_store'
                      "
                      target="_blank"
                      >招商入驻</a
                    >
                  </li>
                  <li>
                    <a :href="CurrentEnvPrefix.newMain" target="_blank"
                      >商家登录</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >我的商城 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li><a :href="orderListLink" target="_blank">订单列表</a></li>
                </ul>
              </div>
            </li>
            <!-- <li class="qm-ul-li">
								<div class="qm-ch-div"><a href="javascript:;">我的收藏 <i class="fa fa-angle-down" aria-hidden="true"></i></a></div>
								<div class="qm-ch-div1">
									<ul class="qm-ch-ul">
										<li><a href="http://www.fangzhibao.com/shop/index.php?act=member_favorites&op=fglist" target="_blank">商品收藏</a></li>
										<li><a href="http://www.fangzhibao.com/shop/index.php?act=member_favorites&op=fslist" target="_blank">店铺收藏</a></li>
									</ul>
								</div>
							</li> -->
            <!-- <li class="qm-ul-li"><div class="qm-ch-div"><a href="http://search.fangzhibao.com//search/index/transport?store_id=3071" target="_blank">运费测算</a></div></li> -->
            <li class="qm-ul-li qm-ul-li-wx" style="width: 80px;">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >在线客服 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a href="javascript:;" class="zcBtn"
                      >在线客服
                      <!-- <img src="../../assets/image/kf_red.png" style="width:16px;height:16px;"> --></a
                    >
                  </li>
                  <!-- <li>
											<a href="javascript:;">微信客服 <img src="../../assets/image/wx1.png" style="width:16px;height:16px;"></a>
											<img :src="CurrentEnvPrefix.main+'/shop/templates/default/images/wxkf.jpg'" style="margin:5px;">
										</li> -->
                </ul>
              </div>
            </li>
            <li class="qm-ul-li qm-ul-li-rx">
              <div class="ng-nav-tel">
                <span class="ng-tel-title">服务热线：</span>
                <span class="ng-tel-nub main-color">{{
                  site_phone.value
                }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.input-file {
  display: none;
}
.home-tab-hover {
  margin-top: 32px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 6px 14px;
  width: 280px;
  border-radius: 4px;
}
.home-tab-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
}
.home-tab-list .site-row-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
.home-tab-list .site-row-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 16px 0 8px;
  white-space: nowrap;
}
.home-tab-list .site-row-name {
  font-size: 14px;
  color: #666;
  margin-right: 16px;
}
.home-tab-list .site-row-name:last-child {
  margin-right: 0;
}
.home-tab-list .site-row-name:hover {
  color: var(--main-color);
}
</style>
<script>
import Cookies from "js-cookie";
import { CurrentEnvPrefix } from "config/urlprefix.js";
import _common from "../../global/js/common";
export default {
  // props: {
  //   siteData: {
  //     type: Object,
  //     required: false,
  //     default: {}
  //   }
  // },
  data() {
    return {
      CurrentEnvPrefix,
      membername: "",
      ref_url: "",
      member_mobile: "",
      userLink: "",
      orderListLink: "",
      site_phone: "",
      sitelist: [],
      siteData: {},
      siteDataObj: {},
      sitename: "",
      sitehost: "",
      site_group: []
    };
  },
  methods: {
    checkPower(modules) {
      return this.$Api.get({
        api: this.Common.getSourec().plapi + "/alpha_test/check_power",
        param: { modules }
      });
    },
    memberLink(e) {
      this.userLink = _common.getlinkToErpUrl("/#/account/info", "", false);
      this.orderListLink = _common.getlinkToErpUrl(
        "/#/trade/orderhandle",
        "&key=0",
        false
      );
    },
    goout() {
      window.location.href =
        CurrentEnvPrefix.login +
        "/login/index/logout?rewrite_url=" +
        this.ref_url;
    },
    uploadChange(e) {
      var files = e.target.files[0];
      var _formData = new FormData();
      const _this = this;
      _formData.append("name", "card_z");
      _formData.append("key", this.$Api.getMKey());
      _formData.append("card_z", files);
      this.$Api
        .uploadResource(
          {
            api: "/mobile/index.php?act=goods&op=search",
            formdata: _formData
          },
          function(callbackProgress) {
            _this.$nextTick(() => {
              _this.progress = callbackProgress;
              // console.log(_this.progress)
            });
          },
          function(callBackResult) {
            //处理数据，跳到goodslist页面
            var param = callBackResult.data || [];
            var result = param.length > 0 ? param[0] : null;
            if (result) {
              var href =
                CurrentEnvPrefix.main +
                _this.Common.getSourec().sitehost +
                "/shop/index.php?act=search&op=goods_search&goods_id_list=" +
                result;
              window.location.href = href;
            }
          }
        )
        .then(response => {});
    },

    siteClick(child) {
      var href = CurrentEnvPrefix.main + "/" + child.site_code + "/";
      this.$Api.setSiteId(child.site_id);
      this.sitename = child.site_name;
      Cookies.set("site_name", this.sitename);
      window.location.href = href;
    },
    getSetList() {
      this.$Api
        .get({
          api: this.Common.getSourec().plapi + "/site/get_page_site_list"
        })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            this.siteData = response.data.datas;
            this.siteDataObj = this.siteData;
            let data = this.siteDataObj;
            this.sitelist = this.siteDataObj.site_list;
            this.site_group = this.siteDataObj.site_group_all;

            var SystemSiteId = Cookies.get("SystemSiteId")
              ? Cookies.get("SystemSiteId")
              : data.site_id;
            var _this = this;
            this.site_group.forEach(function(item, n, m) {
              if ([1, 2, 4].includes(item.site_group_id)) {
                item.hidden = false;
              } else {
                item.hidden = true;
              }
              item.children.forEach(function(i, n, m) {
                if (i.site_id == SystemSiteId) {
                  _this.sitename = item.site_group_name + "-" + i.site_name;
                  Cookies.set("site_name", _this.sitename);
                }
              });
            });
          }
        });
    }
  },

  // watch: {
  //   siteData: function(newVal, oldBal) {
  //     this.siteDataObj = newVal;
  //     let data = this.siteDataObj;
  //     this.sitelist = this.siteDataObj.site_list;
  //     this.site_group = this.siteDataObj.site_group;
  //     var SystemSiteId = Cookies.get("SystemSiteId")
  //       ? Cookies.get("SystemSiteId")
  //       : data.site_id;
  //     var _this = this;
  //     this.site_group.forEach(function(item, n, m) {
  //       item.children.forEach(function(i, n, m) {
  //         if (i.site_id == SystemSiteId) {
  //           _this.sitename = item.site_group_name + "-" + i.site_name;
  //         }
  //       });
  //     });
  //   }
  // },
  mounted() {
    var _this = this;
    _this.getSetList();
    setTimeout(function() {
      var site = _this.Common.getSourec().site;
      _this.site_phone = site ? site.site_phone : "";
    }, 500);
    this.membername = Cookies.get("member_name") || "";
    this.member_mobile = Cookies.get("member_mobile") || "";
    if (Cookies.get("key")) {
      this.$Api.setMKey(Cookies.get("key"));
      this.memberLink();
    }
    this.ref_url = encodeURIComponent(window.location.href);

    var member_name = Cookies.get("member_name");
    var member_mobile = Cookies.get("member_mobile");
    var member_id = Cookies.get("partner_id");
    (function(w, d, e, x) {
      w[e] = function() {
        w.cbk = w.cbk || [];
        w.cbk.push(arguments);
      };
      x = d.createElement("script");
      x.async = true;
      x.id = "zhichiScript";
      (x.className = "zcBtn"), //该class可自行设置，只需要在使用的自定义入口上同名即可
        (x.src =
          "https://zhaojiafang.soboten.com/chat/frame/v2/entrance.js?sysnum=5182b72b5d8d40259b4b0c8f93baeaa0");
      d.body.appendChild(x);
    })(window, document, "zc");
    zc("config", {
      //设置自定义按钮生效
      custom: true,
      to_customsys_open_style: 1,
      msg_flag: 1,
      uname: member_name,
      // tel:member_mobile,
      partnerid: member_id
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/publictop.vue